import { Skeleton } from '@/shared/ui/skeleton'

/**
 * The pending state for a page *inside* the shell — the router's default, and
 * the one that shows on every navigation between tiles.
 *
 * It is not `AppShellSkeleton`, and the difference is the whole point. That one
 * draws the rail and the content column because it stands in for a layout that
 * has not mounted yet. Used for a child route it drew them a second time,
 * nested inside the layout already on screen: a ghost capsule floating in the
 * middle of the page and the column shoved 86px to the right until the data
 * landed. Two jobs, two components.
 *
 * The header block is sized to `PageHeader` — an h1 at 22–24/1.25 over one line
 * of description — because the top of the page is where the eye is, and it is
 * the part that must not move when the real page arrives. What follows is
 * whatever the route puts there and cannot be predicted from here; routes with
 * a shape worth reserving should pass their own `pendingComponent`.
 */
export function PagePending() {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end gap-4">
        <div className="min-w-65 flex-1">
          <Skeleton className="h-7.5 w-56" />
          <Skeleton className="mt-2 h-5 w-96 max-w-full" />
        </div>
        <Skeleton className="h-control-sm w-40 rounded-lg" />
      </div>

      <Skeleton className="h-11" />
      <Skeleton className="h-11" />
      <Skeleton className="h-11" />
    </div>
  )
}
